module.exports = "<div>\n  <h1>{{ buttonCtrl.name }}</h1>\n</div>\n";


/*****************
 ** WEBPACK FOOTER
 ** ./common/button/button.html
 ** module id = 28
 ** module chunks = 0
 **/